import dayjs from 'dayjs'
import rt from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn'
import store from '@/store'

const dateFilter = (val, format = 'YYYY-MM-DD') => {
  if (!isNaN(val)) {
    val = parseInt(val)
  }

  return dayjs(val).format(format)
}

// 格式化日期函数
export const dataFormat = (val, format = 'YYYY-MM-DD') => {
  // 空值/无效值直接返回短横线
  if (!val || val === 'null' || val === 'undefined') {
    return '-'
  }

  try {
    // 处理时间戳（兼容秒/毫秒级）
    let dateVal = val
    if (typeof val === 'number') {
      // 如果是10位时间戳（秒），转成13位（毫秒）
      dateVal = val.toString().length === 10 ? val * 1000 : val
    }
    // 使用dayjs格式化
    return dayjs(dateVal).format(format)
  } catch (error) {
    // 格式化失败返回短横线，避免Excel出现错误值
    console.warn('日期格式化失败：', val, error)
    return '-'
  }
}

dayjs.extend(rt)
function relativeTime(val) {
  if (!isNaN(val)) {
    val = parseInt(val)
  }
  return dayjs()
    .locale(store.getters.language === 'zh' ? 'zh-cn' : 'en')
    .to(dayjs(val))
}

export default app => {
  app.config.globalProperties.$filters = {
    dateFilter,
    relativeTime
  }
}
